import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async changePassword(current_password: string, password: string, password_confirmation: string) {
    return await this.call('/spa/user/password', {
      method: 'put',
      body: { current_password, password, password_confirmation },
    })
  }

  async passwordConfirmation() {
    return await this.call('/spa/user/confirmed-password-status', {
      method: 'get',
    })
  }

  async confirmPassword(password: string) {
    return await this.call('/spa/user/confirm-password', {
      method: 'post',
      body: { password },
    })
  }
}
